import { useCallback } from "react";
import { Box, Flex, Icon, Text, useToast } from "@chakra-ui/react";
import { MdOutlineContentCopy } from "react-icons/md";
import { copyToClipboard } from "../utils/copyToClipBoard";
import Image from "next/image";

interface WalletDetails {
  disconnect: () => void;
  address: string;
  walletName: string;
  icon?: any;
  trackWalletAddressCopy?: () => void;
}

interface WalletDisconnectModalBodyProps {
  walletDetails: WalletDetails;
}

export const WalletDisconnectModalBody = ({
  walletDetails,
}: WalletDisconnectModalBodyProps) => {
  const { address, walletName, disconnect, icon, trackWalletAddressCopy } =
    walletDetails;
  const toast = useToast();
  const handleAddressCopy = useCallback(() => {
    trackWalletAddressCopy && trackWalletAddressCopy();
    copyToClipboard(address);
    toast({
      description: "Address Copied",
      status: "success",
      duration: 2000,
      position: "top",
      isClosable: true,
    });
  }, [toast, address]);

  return (
    <>
      <Text fontSize="14px" m={0}>
        Connected with {walletName}
      </Text>
      <Flex
        justifyContent="space-between"
        px={5}
        bg="brand.textBg"
        mt="1rem"
        borderRadius="0.5rem"
        fontSize="16px"
      >
        <Flex>
          {icon && (
            <Box
              height="20px"
              borderRadius="50%"
              overflow="hidden"
              bgColor="black"
              mt="1.1rem"
              mr="0.5rem"
            >
              <Image src={icon} width="20px" height="20px" />
            </Box>
          )}
          <Text>{address}</Text>
        </Flex>
        <Box
          color="brand.primary"
          fontSize="14px"
          fontWeight="700"
          cursor="pointer"
          onClick={disconnect}
          _hover={{
            textDecoration: "underline",
            textDecorationStyle: "dotted",
          }}
        >
          <Text>DISCONNECT</Text>
        </Box>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center">
        <Flex
          color="brand.primary"
          fontWeight="600"
          cursor="pointer"
          onClick={handleAddressCopy}
          alignItems="center"
          fontSize="14px"
        >
          <Icon as={MdOutlineContentCopy} />
          <Text
            textDecoration="underline"
            textDecorationStyle="dotted"
            textUnderlineOffset="4px"
            ml="7px"
          >
            Copy Address
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

export default WalletDisconnectModalBody;
